import { CaseReducer, createSlice } from '@reduxjs/toolkit';

import { apiHostname } from 'shared/constants';
import { serializeLocationHeader } from 'shared/helpers';
import { AlphamartHttpError, ConvertersGroup, Coords } from 'shared/types';
import {
  GenericStoreReducer,
  GenericStoreSlice,
  GenericThunk,
  getGenericReducers,
} from './shared/createGenericStoreSlice';

interface FetchConvertersGroupSlice extends GenericStoreSlice {
  convertersGroups: ConvertersGroup[];
}

type FetchConvertersGroupReducer = GenericStoreReducer<FetchConvertersGroupSlice> & {
  clearConvertersGroups: CaseReducer<FetchConvertersGroupSlice, { type: string }>;
};

const fetchConvertersGroupsSlice = createSlice<
  FetchConvertersGroupSlice,
  FetchConvertersGroupReducer
>({
  name: 'convertersGroups',
  initialState: {
    convertersGroups: [],
    isPending: false,
    error: undefined,
  },
  reducers: {
    ...getGenericReducers(payload => ({
      convertersGroups: payload,
    })),
    clearConvertersGroups: state => ({
      ...state,
      convertersGroups: [],
    }),
  },
});

export const {
  pending: fetchConvertersGroupsAction,
  success: fetchConvertersGroupsSuccessAction,
  failure: fetchConvertersGroupsFailureAction,
  clearConvertersGroups,
} = fetchConvertersGroupsSlice.actions;

export const fetchConvertersGroups =
  (position?: Coords): GenericThunk =>
  async (dispatch, getState, httpClient) => {
    try {
      dispatch(fetchConvertersGroupsAction());
      const headers = position && { 'user-location': serializeLocationHeader(position) };

      const convertersGroups = await httpClient.get(`${apiHostname}/api/converters/groups`, {
        headers,
      });
      dispatch(fetchConvertersGroupsSuccessAction(convertersGroups.data));
    } catch (error) {
      dispatch(
        fetchConvertersGroupsFailureAction((error as AlphamartHttpError)?.response?.data.message),
      );
      return Promise.reject(error);
    }
  };

export default fetchConvertersGroupsSlice.reducer;
